import TopBannerCarousel from '../../components/feature/TopBannerCarousel';
import OrderTicker from '../../components/feature/OrderTicker';
import ReviewTicker from '../../components/feature/ReviewTicker';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import SpecialOffers from '../../components/feature/SpecialOffers';
import FeaturedProducts from '../../components/feature/FeaturedProducts';
import PaymentShippingInfo from '../../components/feature/PaymentShippingInfo';
import FeedbackForm from '../../components/feature/FeedbackForm';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div>
      {/* Top Banner Carousel */}
      <TopBannerCarousel />
      
      {/* Why Choose Us */}
      <WhyChooseUs />
      
      {/* Order & Review Tickers */}
      <div className="w-full bg-gray-50 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Left: Order Ticker */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Recent Orders</h3>
              <OrderTicker />
            </div>
            
            {/* Right: Review Ticker */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Customer Reviews</h3>
              <ReviewTicker />
            </div>
          </div>
        </div>
      </div>
      
      {/* Special Offers */}
      <SpecialOffers />
      
      {/* Featured Products */}
      <FeaturedProducts />
      
      {/* Payment & Shipping Info */}
      <PaymentShippingInfo />
      
      {/* Feedback Form */}
      <FeedbackForm />
      
      {/* Footer */}
      <Footer />
    </div>
  );
}
